export default {
  getRisk_factorsByMemberid: "BackEnd/getRisk_factorsByMemberid",
  getMyRisk_factorsByMemberid: "BackEnd/getMyRisk_factorsByMemberid",
  setRisk_factors: "BackEnd/setRisk_factors",
  updateRisk_factors: "BackEnd/updateRisk_factors",
};
